import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { resolveMediaUrl } from '../../../utilities/BL/MvpXolosZone';

/**
 * COMPONENTE: MvpXolosZone OVERLAY (DESIGN / CHILD VISUAL)
 * ------------------------------------------------------------------
 * Este componente maneja la visualización e interactividad del Overlay.
 * Renderiza dos códigos QR con coordenadas exactas para la dinámica
 * "Convivencia en la zona".
 * ------------------------------------------------------------------
 */
export function MvpXolosZone({ flowState, offsetY, bannerImageMdUrl, bannerImageLgUrl }) {
    // ZERO-CANVAS RULE: No renderizar nada si está en estado 'idle'
    if (flowState === 'idle') return null;

    const qrValue = `${window.location.origin}/xolos-mvp-zone?s=obs`;

    const mdSrc = bannerImageMdUrl ? resolveMediaUrl(bannerImageMdUrl) : '/img/overlays/rubaquiz/cintillo-ruba-1536-x-180-px.png';
    const lgSrc = bannerImageLgUrl ? resolveMediaUrl(bannerImageLgUrl) : '/img/overlays/rubaquiz/cintillo-ruba-1920-x-180-px.png';

    return (
        <div className="mvpxoloszone-overlay" style={{ bottom: `${offsetY}px` }}>
            <div className={`mvpxoloszone-overlay__banner mvpxoloszone-overlay__banner--${flowState}`}>
                {/* 1536px and 1920px images */}
                <img 
                    src={mdSrc} 
                    className='mvpxoloszone-overlay__banner__Image--Md' 
                    alt="MVP Xolos Femenil" 
                />
                <img 
                    src={lgSrc} 
                    className='mvpxoloszone-overlay__banner__Image--Lg' 
                    alt="MVP Xolos Femenil Lg" 
                />
                
                {/* Left QR Code */}
                <div className='mvpxoloszone-overlay__banner__QR-Overlay mvpxoloszone-overlay__banner__QR-Overlay--left'>
                    <QRCodeSVG 
                        value={qrValue} 
                        size={256}
                        style={{ width: '92%', height: '92%', display: 'block' }}
                        bgColor={"#d9d9d9"} 
                        fgColor={"#000000"} 
                        level={"H"} 
                        imageSettings={{
                            src: "/img/overlays/rubaquiz/interaktia-transparent.png",
                            x: undefined,
                            y: undefined,
                            height: 52,
                            width: 52,
                            excavate: true, 
                        }}
                    />
                </div>

                {/* Right QR Code */}
                <div className='mvpxoloszone-overlay__banner__QR-Overlay mvpxoloszone-overlay__banner__QR-Overlay--right'>
                    <QRCodeSVG 
                        value={qrValue} 
                        size={256}
                        style={{ width: '92%', height: '92%', display: 'block' }}
                        bgColor={"#d9d9d9"} 
                        fgColor={"#000000"} 
                        level={"H"} 
                        imageSettings={{
                            src: "/img/overlays/rubaquiz/interaktia-transparent.png",
                            x: undefined,
                            y: undefined,
                            height: 52,
                            width: 52,
                            excavate: true, 
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default MvpXolosZone;
